module.exports = "<listado-general \r\n  [listado]=\"comandos\" \r\n  [titulo]=\"'CONSULTA_SIMPLE' | i18next\"\r\n  [urladicional]=\"''\"\r\n  [modoIconosOn]=\"true\"\r\n  (clickNuevo)=\"navegarANuevaConsultaSimple()\"\r\n  [leyendaListado]=\"'DEFAULT_LEYENDA_HOME' | i18next\">\r\n</listado-general>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/consultaSimple/listado.consulta.simple.component.html
// module id = ../../../../../src/app/private/consultaSimple/listado.consulta.simple.component.html
// module chunks = main